<template>
   <div class="introduction">
        <menuBox :step="6"></menuBox>
        <div class="banner">
            Profil Perusahaan
            <p>Bussan Auto Finance Kapuas Banjarmasin adalah perusahaan pembiayaan otomotif terkemuka di Indonesia, yang berdedikasi untuk menyediakan solusi pembiayaan otomotif yang komprehensif bagi pelanggan. Kami menyediakan layanan kredit mobil dan leasing keuangan yang efisien untuk memenuhi berbagai kebutuhan pelanggan. Melalui tim profesional kami dan platform teknologi canggih, kami terus menyediakan pelanggan dengan solusi keuangan yang inovatif untuk memberikan nilai lebih dan kenyamanan bagi pelanggan. </p>
        </div>
        <div class="introduction-item">
            <div class="item-box">
                <img src="../assets/img-12.png" alt="">
                <div class="item-text">
                    <div class="title">Sejarah perusahaan</div>
                    <div class="text">Didirikan pada tahun 2010, Bussan Auto Finance Kapuas Banjarmasin adalah salah satu perusahaan pembiayaan otomotif terkemuka di Indonesia. Selama bertahun-tahun, kami telah berkomitmen untuk menyediakan pelanggan dengan solusi pembiayaan mobil yang fleksibel dan andal, membantu mereka mewujudkan impian mereka dan menikmati kenyamanan dan kesenangan yang dibawa oleh mobil. </div>
                </div>
            </div>
            <div class="item-box top-px">
                <img src="../assets/img-13.png" alt="">
                <div class="item-text">
                    <div class="title">Layanan kami</div>
                    <div class="text">
                        Layanan kami mencakup berbagai produk pembiayaan otomotif, termasuk kredit otomotif, leasing mobil dan transaksi mobil bekas, dll. Produk kami fleksibel dalam desain dan dapat disesuaikan sesuai dengan kebutuhan khusus pelanggan untuk membantu pelanggan mewujudkan impian mereka membeli mobil dan mengatasi masalah kemacetan modal. Tim layanan kami menganut konsep customer-centricity, memberikan layanan berkualitas tinggi dan efisien, serta memastikan kepuasan dan kepercayaan pelanggan.
                    </div>
                </div>
            </div>
            <div class="item-box top-px">
                <img src="../assets/img-14.png" alt="">
                <div class="item-text">
                    <div class="title">Tim kita</div>
                    <div class="text">
                        Bussan Auto Finance Kapuas Banjarmasin memiliki tim yang profesional dan berpengalaman, termasuk ahli keuangan otomotif, personel layanan pelanggan dan personel dukungan teknis, dll. Anggota tim kami memiliki pemahaman yang mendalam dan pengalaman praktis yang kaya dalam industri keuangan otomotif, dan mampu menyediakan pelanggan dengan layanan berkualitas tinggi dan solusi yang paling sesuai. Tim kami selalu berpegang pada nilai-nilai inti inovasi, kolaborasi, integritas, dan mengutamakan pelanggan, terus-menerus menantang diri kami sendiri untuk menyediakan layanan yang lebih baik kepada pelanggan.
                    </div>
                </div>
            </div>
        </div>
        
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
.banner{
    width: 100%;
    height: 480px;
    background: url(../assets/banner-3.png);
    background-size: 100% 100%;
    font-size: 40px;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    p{
        padding: 24px 360px;
        font-size: 18px;
        font-weight: 500;
        color: #FFFFFF;
    }
}
.introduction-item{
    padding: 120px 360px;
    .top-px{
        margin-top: 80px;
    }
    .item-box{
        display: flex;
        // justify-content: space-between;
        img{
            width: 470px;
            height: 320px;
        }
        .item-text{
            margin-left: 40px;
            .title{
                font-size: 32px;
                font-weight: 500;
                color: #1C539D;
            }
            .text{
                font-size: 18px;
                font-weight: 500;
                color: #999999;
                margin-top: 16px;
            }
        }
    }
}

</style>